// extracted by extract-css-chunks-webpack-plugin
module.exports = {"SectionTitle":"SectionTitle","SectionTitle__icon":"SectionTitle__icon"};